export const mBusAddressingModeEnum = {
  primary: 'primary',
  secondary: 'secondary',
} as const

export type MBusAddressingModeEnum = (typeof mBusAddressingModeEnum)[keyof typeof mBusAddressingModeEnum]

export type MBusAddressingMode = MBusAddressingModeEnum